import moment from 'moment';
import Tooltip from 'rc-tooltip';

import {
	JournalDeviceStatus,
	JournalDto,
	explainJournalDeviceStatus,
	translateJournalDeviceStatus,
	translateJournalError,
	translateJournalType,
} from '~modules/journal/model';
import { formatUserDevice } from '~modules/user-device/model';
import { UserHelper } from '~modules/user/model';
import { config } from '~shared/config';

type SessionErrorItemProps = {
	error: JournalDto;
};

/**
 * Класс подсветки: точное нарушение - красным, вероятное и подозрительное - оранжевым
 */
function statusClassName(status: JournalDeviceStatus): string {
	return status === JournalDeviceStatus.violation ? 'cabinet-errors__violation' : 'cabinet-errors__suspicious';
}

export function SessionErrorItem({ error }: SessionErrorItemProps) {
	const reason = error.error ? translateJournalError(error.error) : translateJournalType(error.type);
	const deviceStatus = error.device_status ?? JournalDeviceStatus.ok;
	const deviceReason = translateJournalDeviceStatus(deviceStatus);

	return (
		<tr>
			<td>{moment(error.date).format('DD.MM.YYYY HH:mm:ss')}</td>
			<td>{UserHelper.getName(error.user)}</td>
			<td>{error.device?.section?.title ?? ''}</td>
			<td>
				{reason}
				{deviceReason && (
					<Tooltip placement="top" overlay={explainJournalDeviceStatus(deviceStatus)}>
						<div className={statusClassName(deviceStatus)}>
							{deviceReason}
							{error.is_incognito && ' (приватный режим)'}
						</div>
					</Tooltip>
				)}
			</td>
			<td>{formatUserDevice(error.user_device)}</td>
			<td>{error.device_users?.map(itm => itm.name).join(', ') ?? ''}</td>
			<td>
				{error.ip ?? ''}
				{error.network_type ? ` (${error.network_type})` : ''}
			</td>
			<td>
				{error.photo?.id && (
					<a href={`${config.backUrl}/api/upload/${error.photo.id}`} target="_blank" rel="noreferrer">
						Фото
					</a>
				)}
			</td>
			<td></td>
		</tr>
	);
}
